import { ICopyable, IJsonSerializable, IOpChangeState } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpOperator } from '../core/op-operator'
import { OpConsumerNotificationContent } from './op-consumer-notification-content'

export class OpConsumerNotificationCollection implements IOpChangeState, IJsonSerializable, ICopyable<OpConsumerNotificationCollection> {

    // #region Properties

    public idConsumer: number
    public idOperator: number

    // #endregion


    // #region Navigation Properties

    public operator: OpOperator
    public notifications: OpConsumerNotificationContent[] = []

    // #endregion


    // #region Ctor

    constructor(opObj: any= null) {
        if (opObj instanceof OpConsumerNotificationCollection) {
            this.copy(<OpConsumerNotificationCollection>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion


    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IJsonSerializable implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idConsumer = opObj.IdConsumer
            this.idOperator = opObj.IdOperator

            if (opObj.Notifications) {
                this.notifications.push(...opObj.Notifications.map((data: OpConsumerNotificationContent) => new OpConsumerNotificationContent(data)))
            }

            this.opState = opObj.OpState
            this.operator = opObj._operator != null ? new OpOperator(opObj._operator) : null
        } 
    }

    public toJSON(compressed: boolean = false): any {
        return {
            IdConsumer: this.idConsumer,
            IdOperator: this.idOperator,
            Notifications: this.notifications ? this.notifications.map((content: OpConsumerNotificationContent) => content.toJSON()) : null,
            opState: this.opState,
            _operator: this.operator != null ? this.operator.toJSON() :null
        }
    }

    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpConsumerNotificationCollection {
        const consumerNotificationCollection: OpConsumerNotificationCollection = new OpConsumerNotificationCollection()

        consumerNotificationCollection.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return consumerNotificationCollection
    }

    public copy(source: OpConsumerNotificationCollection, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.operator = source.operator // TODO Zaimplementować ICopyable

            const notifications: OpConsumerNotificationContent[] = source.notifications.map((module: OpConsumerNotificationContent) => {
                return module.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            })

            this.notifications = notifications
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idConsumer = source.idConsumer
        this.idOperator = source.idOperator

        this.opState = source.opState
    }

    // #endregion 
}